import { Observable } from 'rxjs';
import { CommercialConsentPublicResponseModel } from '../../models/comercial/commercial-consent.model';
import { ComercialRepository } from '../../repositories/comercial.repository';

export class GetCommercialConsentUseCase {
  constructor(private comercialRepository: ComercialRepository) {}

  execute(params: { token: string }): Observable<CommercialConsentPublicResponseModel> {
    return this.comercialRepository.getCommercialConsent(params);
  }
}
